// extracted by mini-css-extract-plugin
export default {"QueueLabelContainer":"activeorders_QueueLabelContainer__8tkxe","PointerIcon":"activeorders_PointerIcon__yw162","DisabledButton":"activeorders_DisabledButton__hSz6l"};